import React from "react";
import { Link } from "react-router-dom";

/**
 * SubMenu Wrapper
 * A reusable icon-based menu that appears below the header.
 * Use SubeMenuItem(s) inside
 * Optional `decoration` renders behind the items (e.g. seasonal art)
 */
export default function SubMenuWrapper({ children, bar = false, decoration = null }) {
    return (
        <div className={`relative ${bar ? "w-full bg-gray-100 py-1.5" : "bg-gray-100 py-1.5 rounded-lg"}`}>
            {decoration}
            <div className="relative z-[1] flex justify-center items-start gap-4">
                {children}
            </div>
        </div>
    );
}

export function SubMenuItem({ icon, label, onClick, to }) {
    const content = (
        <>
            <div className="w-7 h-7 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors">
                {icon}
            </div>
            <span className="text-[10px] text-gray-600 mt-0.5 text-center leading-tight max-w-[60px]">
                {label}
            </span>
        </>
    );

    const className = "flex flex-col items-center cursor-pointer no-underline";

    if (to) {
        return (
            <Link to={to} className={className}>
                {content}
            </Link>
        );
    }

    return (
        <button onClick={onClick} className={`${className} bg-transparent border-none p-0`}>
            {content}
        </button>
    );
}
